import { render, staticRenderFns } from "./NeedFromTeam.vue?vue&type=template&id=374df1a0&scoped=true&"
import script from "./NeedFromTeam.vue?vue&type=script&lang=js&"
export * from "./NeedFromTeam.vue?vue&type=script&lang=js&"
import style0 from "./NeedFromTeam.vue?vue&type=style&index=0&id=374df1a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374df1a0",
  null
  
)

export default component.exports